<ng-container *ngIf="cardDetails?.length! > 0">
  <div
    class="detail-card-wrapper"
    *ngFor="let cardDetail of cardDetails; let ind = index"
    [id]="'selectable-detail-card-wrapper-' + ind"
  >
    <app-card
      *ngIf="cardDetails"
      padding="0"
      id="selectable-detail-card-app-card"
      (cardClick)="onCardClickHandler(cardDetail)"
      [isHoverable]="cardDetail.isClickable ?? isClickable"
    >
      <div class="card-content" id="selectable-detail-card-card-content-wrapper">
        <div
          [class]="getCardContentClass(cardDetail)"
          id="selectable-detail-card-card-content"
        >
          <div
            class="error-wrapper"
            id="selectable-detail-card-error-wrapper"
            *ngIf="cardDetail.errorTagTextKey"
          >
            <app-text
              id="selectable-detail-card-error-message"
              [textStyleType]="'mobile-overline'"
              >{{ cardDetail.errorTagTextKey | translate | uppercase }}</app-text
            >
          </div>
          <div
            id="selectable-detail-card-label-wrapper"
            class="card-label-wrapper"
            *ngIf="cardDetail.cardLabelKey"
          >
            <app-text id="selectable-detail-card-label" textStyleType="mobile-overline">{{
              cardDetail.cardLabelKey! | translate
            }}</app-text>
          </div>
          <div class="content-wrapper" id="selectable-detail-card-content-wrapper">
            <div class="first-detail" id="selectable-detail-card-first-detail">
              <ng-container *ngIf="cardDetail.showCheckbox"
                ><app-checkbox
                  [checkboxData]="''"
                  [checkboxId]="cardDetail.id!"
                  [defaultChecked]="cardDetail.isDefaultChecked!"
                  (checkboxCheck)="onCheckboxSelection($event)"
                  id="selectable-detail-card-checkbox"
                ></app-checkbox
              ></ng-container>

              <app-title-subtitle
                [title]="cardDetail.primaryHeadingKey | translate"
                [titleFontStyle]="'mobile-overline'"
                [subtitle]="cardDetail.primaryData"
                [subtitleFontStyle]="'headline4'"
                [subtitlePadding]="'0'"
                [showTitleRightIcon]="
                  !!(cardDetail.rightTitleIcons && cardDetail.rightTitleIcons.primaryIcon)
                "
                [rightTitleIconName]="
                  (cardDetail.rightTitleIcons &&
                    cardDetail.rightTitleIcons.primaryIcon?.name) ||
                  ''
                "
                [rightTitleIconClassNames]="
                  (cardDetail.rightTitleIcons &&
                    cardDetail.rightTitleIcons.primaryIcon?.classNames) ||
                  []
                "
                id="selectable-detail-card-primary-data"
              ></app-title-subtitle>
            </div>
            <div class="second-detail">
              <app-title-subtitle
                [title]="cardDetail.secondaryHeadingKey | translate"
                [titleFontStyle]="'mobile-overline'"
                [subtitle]="cardDetail.secondaryData"
                [subtitleFontStyle]="'headline4'"
                [subtitlePadding]="'0'"
                [showTitleRightIcon]="
                  !!(
                    cardDetail.rightTitleIcons && cardDetail.rightTitleIcons.secondaryIcon
                  )
                "
                [rightTitleIconName]="
                  (cardDetail.rightTitleIcons &&
                    cardDetail.rightTitleIcons.secondaryIcon?.name) ||
                  ''
                "
                [rightTitleIconClassNames]="
                  (cardDetail.rightTitleIcons &&
                    cardDetail.rightTitleIcons.secondaryIcon?.classNames) ||
                  []
                "
                [otherTitleIcons]="
                  (cardDetail.otherTitleIcons &&
                    cardDetail.otherTitleIcons.secondaryIcon) ||
                  []
                "
                id="selectable-detail-card-secondary-data"
              ></app-title-subtitle>
            </div>
            <div class="third-detail">
              <app-title-subtitle
                [ngClass]="[cardDetail.tertiaryDataColorType || 'dark-grey']"
                [title]="cardDetail.tertiaryHeadingKey | translate"
                [titleFontStyle]="'mobile-overline'"
                [subtitle]="cardDetail.tertiaryData"
                [subtitleFontStyle]="'headline4'"
                [subtitlePadding]="'0'"
                id="selectable-detail-card-tertiary-data"
                [titleSubtitleClassName]="titleSubtitleClassName"
                [showTitleRightIcon]="
                  !!(cardDetail.rightTitleIcons && cardDetail.rightTitleIcons.thirdIcon)
                "
                [rightTitleIconName]="
                  (cardDetail.rightTitleIcons &&
                    cardDetail.rightTitleIcons.thirdIcon?.name) ||
                  ''
                "
                [rightTitleIconClassNames]="
                  (cardDetail.rightTitleIcons &&
                    cardDetail.rightTitleIcons.thirdIcon?.classNames) ||
                  []
                "
              ></app-title-subtitle>
            </div>
            <div class="fourth-detail">
              <ng-container *ngIf="cardDetail.showStatusIcon">
                <app-icon
                  class="status-icon"
                  id="line-item-icon"
                  [name]="'check_circle'"
                  size="1.3em"
                ></app-icon>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </app-card>
  </div>
</ng-container>
